enum TicketTabsEnum {
    TicketsInAttendance = 'ticketsInAttendance',
    TicketsInQueue = 'ticketsInQueue',
    Agents = 'agents',
    Tags = 'tags',
}

export default TicketTabsEnum;
